import { defineMessages } from 'react-intl';

export const topBarTranslations = defineMessages({
  pretailoringButton: {
    id: 'topbar.button.pretailoring',
    defaultMessage: 'Tailoring Questions',
    description: 'Topbar button pretailoring',
  },
  tailoringButton: {
    id: 'topbar.button.tailoring',
    defaultMessage: 'Final Tailoring',
    description: 'Topbar button tailoring',
  },
  cancelButton: {
    id: 'topbar.button.cancel',
    defaultMessage: 'Cancel',
    description: 'Topbar button cancel',
  },
  backButton: {
    id: 'topbar.button.back',
    defaultMessage: 'Back',
    description: 'Topbar button back',
  },
  backToProducts: {
    id: 'topbar.button.backToProducts',
    defaultMessage: 'Back to products',
    description: 'Topbar button back to products',
  },
  saveButton: {
    id: 'topbar.button.save',
    defaultMessage: 'Save & Next',
    description: 'Topbar button save',
  },
  export: {
    id: 'topbar.button.export',
    defaultMessage: 'Export',
    description: 'Topbar button export',
  },
});
